import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const AddReferralCode: React.FC<IconProps> = ({
  color = '#fff',
  size = 21,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M12.5 1.9502C18.0504 1.9502 22.5498 6.44954 22.5498 12C22.5498 17.5504 18.0504 22.0498 12.5 22.0498C6.94954 22.0498 2.4502 17.5504 2.4502 12C2.4502 6.44954 6.94954 1.9502 12.5 1.9502ZM12.5 4.0498C8.10933 4.0498 4.5498 7.60933 4.5498 12C4.5498 16.3907 8.10933 19.9502 12.5 19.9502C16.8907 19.9502 20.4502 16.3907 20.4502 12C20.4502 7.60933 16.8907 4.0498 12.5 4.0498ZM13 6.9502C13.3038 6.9502 13.5498 7.19624 13.5498 7.5V10.9502H17C17.3038 10.9502 17.5498 11.1962 17.5498 11.5V12.5C17.5498 12.8038 17.3038 13.0498 17 13.0498H13.5498V16.5C13.5498 16.8038 13.3038 17.0498 13 17.0498H12C11.6962 17.0498 11.4502 16.8038 11.4502 16.5V13.0498H8C7.69624 13.0498 7.4502 12.8038 7.4502 12.5V11.5C7.4502 11.1962 7.69624 10.9502 8 10.9502H11.4502V7.5C11.4502 7.19624 11.6962 6.9502 12 6.9502H13Z"
      fill={color}
      stroke="white"
      strokeWidth="0.1"
    />
  </svg>
)
